module.exports = __webpack_public_path__ + "static/img/user-vip.bea45c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-vip.png
// module id = pbtr
// module chunks = 1